import React, { useEffect, useState, useRef } from 'react';
import { Grid } from '@mui/material';
import MainCard from '../../../ui-component/cards/MainCard';
import SecondaryAction from '../../../ui-component/cards/CardSecondaryAction';
import { gridSpacing } from '../../../store/constant';
import { Label, Tooltip } from 'reactstrap';
import axiosInstance from '../../../axiosInstance';
import { IconDownload, IconUpload } from '@tabler/icons';
import { useSelector } from 'react-redux';
import configData from '../../../config';
import uploadCloud from '../../../assets/images/icons/cloud-upload-svgrepo-com.svg';
import * as XLSX from 'xlsx';

const icons = {
    IconDownload,
    IconUpload
};

const columns = [
    { title: 'Month', field: 'month' },
    { title: 'Account Name', field: 'account_name' },
    { title: 'Amount', field: 'amount' },
    { title: 'Currency', field: 'currency' }
];



function CummlativeKmRun() {
    const [apiData, setAPIData] = useState([]);
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const [fileInputKey, setFileInputKey] = useState(0);
    const [tbData, setTBData] = useState();
    // const [tyre, setTyre] = useState('Passive_Tyre_report');

    const account = useSelector((state) => state.account);
    const org_id = useSelector((state) => (state?.account?.org?.id ? state?.account?.org?.id : state?.account?.org_data?.data?.id));

    // Toggle tooltip visibility
    const toggleTooltip = () => setTooltipOpen(!tooltipOpen);

    const getData = async () => {
        // setLoading(true);
        try {
            //     const res = await axiosInstance.get(`https://api.projectivetech.com/account/trial_balance?org_id=${}`);
            const res = await axiosInstance.get(configData.API_SERVER + `/account/trial_balance?org_id=${account.org.id}`);
            //     const res = await axiosInstance.get(`http://127.0.0.1:8000/account/trial_balance?org_id=${account.org.id}`);
            setAPIData(res.data.data);
        } catch (error) {
            setAPIData([]);
        }
    };


    const TableData = apiData;
    useEffect(() => {
        getData();
    }, []);

    const [selectedFile, setSelectedFile] = useState(null);

    const handleFileChange = async (file) => {
        console.log(file);

        const fileExtension = getFileExtension(file.name);
        console.log(fileExtension);
        if (isValidFileExtension(fileExtension)) {
            setSelectedFile(file);
            setFileInputKey(prevKey => prevKey + 1);
            // handleUpload(file);
        } else {
            // Invalid file format
            alert('Invalid file format. Please select a CSV, XLSX, or XLS file.');
        }
        // setSelectedFile(file)
    };

    const getFileExtension = (filename) => {
        return filename.split('.').pop().toLowerCase();
    };

    const isValidFileExtension = (extension) => {
        const allowedExtensions = ['csv', 'xlsx', 'xls'];
        return allowedExtensions.includes(extension);
    };

    const fileInputRef = useRef(null);
    
    const handleUpload = async () => {
        console.log('in handle upload');
        if (selectedFile) {
            const formData = new FormData();
            formData.append('file', selectedFile);
            formData.append('org_id', org_id);
            
            const response = await axiosInstance.post('https://api.projectivetech.com/account/upload_trail_balance_sheet',formData);
            // const response = await axiosInstance.post('http://127.0.0.1:8000/account/upload_trail_balance_sheet',formData);

            setSelectedFile(null);
            console.log(response);
            alert('Trial Balance successfully uploaded.');
            fileInputRef.current.value = '';
        } else {
            alert('Please upload file in appropriate format.');
        }
    };

    useEffect(() => {
        if (selectedFile) handleUpload();
    }, [selectedFile]);


    // Export TB template api call
    const exportTB = async ()=>{
        try {
            const res = await axiosInstance.get(`https://api.projectivetech.com/account/trial_balance?org_id=${org_id}`)
            // const res = await axiosInstance.get(`http://127.0.0.1:8000/account/trial_balance?org_id=${org_id}`)
            setTBData(res.data.data);
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
      if(tbData)
      exportToExcel()
    }, [tbData])
    

    const exportToExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(tbData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    
        const buffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' }); // Specify type as buffer
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'TB Template.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };

    return (
        <>
            <MainCard title="Trial Balance" secondary={<SecondaryAction />}>
                <Grid container spacing={gridSpacing} style={{ padding: '0px' }}>
                    <Grid item lg={12} sm={12} md={12}>
                        <div className="uploadMainOpening">
                            <div className="uploadOpening">
                                <img className="uploadCloud" src={uploadCloud} alt="" />
                                <Label>Upload Trial Balance</Label>
                                <div style={{ padding: '0 10px' }}>
                                    <Label
                                        onClick={()=> document.getElementById('hiddenFileInput1').click()}
                                        id="chooseFileButton"
                                        className="chooseFileBtn1"
                                        style={{
                                            cursor: 'pointer',
                                            color: 'white',
                                            background: '#2196f3',
                                            borderRadius: '4px',
                                            padding: '5.5px 13px'
                                        }}
                                    >
                                        Choose File
                                    </Label>
                                    <Label
                                        id="chooseFileButton1"
                                        className="chooseFileBtn1"
                                        style={{
                                            cursor: 'pointer',
                                            color: 'white',
                                            background: '#198754',
                                            borderRadius: '4px',
                                            padding: '5.5px 10px',
                                            marginLeft: '3px'
                                        }}
                                        onClick={exportTB}
                                    >
                                        <IconDownload stroke={1.5} size="1.2rem" style={{ marginTop: '-6px' }} />
                                    </Label>
                                    <Tooltip
                                        isOpen={tooltipOpen}
                                        target="chooseFileButton1" // ID of the target element
                                        toggle={toggleTooltip} // Toggle function
                                    >
                                        Download TB Template
                                    </Tooltip>
                                </div>

                                <input
                                    // name="resultUpload"
                                    key={fileInputKey}
                                    type="file"
                                    ref={fileInputRef}
                                    style={{ display: 'none' }}
                                    id="hiddenFileInput1"
                                    onChange={(event)=> handleFileChange(event.target.files[0])}
                                />
                                <div style={{ display: 'flex' }}>
                                    <span style={{ fontSize: '12.7px', fontWeight: '400' }}>Maximum File Size: 5 MB </span>
                                    <span style={{ fontSize: '17px', margin: '-6px 3px 0 3px' }}>|</span>
                                    <span style={{ fontSize: '12.7px', fontWeight: '400' }}> File Format: CSV or TSV or XLS</span>
                                </div>
                            </div>
                        </div>
                    </Grid>
                </Grid>
                <br></br>
                <br></br>
            </MainCard>

            <Grid item xs={12} className="sub_div">
                <Grid container spacing={gridSpacing}>
                    <Grid item lg={12} md={6} sm={6} xs={12}>
                        <Grid className="col-12 col-sm-12 text-center footer_inner_div">&copy; {new Date().getFullYear()} IMAGE-I</Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}

export default CummlativeKmRun;
